module.exports = __webpack_public_path__ + "static/media/car.281d0c6d.png";